import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tab} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../components/Banner';

export const StorageExplorerTab = styled(Tab)`
  &&&&& {
    .ui.pointing.menu {
      border-bottom: 2px solid ${globals.MOON_200};

      & > .item {
        font-weight: 600;
        margin: 0;
        border: none;

        padding: 16px 2px;
        margin-right: 36px;

        color: ${globals.MOON_600};
        &:hover,
        &.active {
          color: ${globals.MOON_950};
        }

        &.active {
          border-bottom: 2px solid ${globals.TEAL_550};
          margin-bottom: -2px;
        }
      }
    }
  }
`;

export const InfoBlurb = styled(Banner)`
  margin-bottom: -24px;
`;
